// extracted by mini-css-extract-plugin
export var grid = "_a-5";
export var layout = "_a-0";
export var leftColumn = "_a-1";
export var leftInner = "_a-2";
export var rightColumn = "_a-3";
export var rightInner = "_a-4";